import { render, staticRenderFns } from "./WizardFooter.vue?vue&type=template&id=2dd68c98&scoped=true&lang=html&"
import script from "./WizardFooter.vue?vue&type=script&lang=js&"
export * from "./WizardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd68c98",
  null
  
)

export default component.exports